import React from 'react';
import AdmissionCourse from './AdmissionCourse';

const AdmissionPages = () => {
    return (
        <div className='container-fluid p-5' style={{ marginTop: "80px" }}>
            <AdmissionCourse/>
        </div>
    );
};

export default AdmissionPages;